import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { AccessibilityComponent } from './accessibility/accessibility.component';
import { PrivacyStatementComponent } from './privacy-statement/privacy-statement.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { SolutionsComponent } from './solutions/solutions.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'accessibility', component: AccessibilityComponent },
  { path: 'privacy', component: PrivacyStatementComponent },
  { path: 'terms-conditions', component: TermsConditionsComponent },
  { path: 'solutions', component: SolutionsComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
